import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { Flex } from "@similarweb/ui-components/foundations";

import { llmsAssets } from "./assets";

const LogoCardOuter = styled(Flex)`
    padding: 12px;
    border-radius: 9px;
    border: 0.846px solid ${colorsPalettes.carbon[0]};
    background-color: rgba(241, 246, 254, 0.2);
    box-shadow: 0px 0px 4.5px rgba(54, 54, 54, 0.08);
`;

const LogoCardInner = styled(Flex)`
    width: 96px;
    height: 96px;
    border-radius: 6px;
    border: 0.922px solid ${colorsPalettes.carbon[50]};
    background-color: ${colorsPalettes.carbon[0]};
    box-shadow: 0px 16.6px 15.7px rgba(14, 30, 62, 0.12);
`;

const LogoImg = styled.img`
    width: 64px;
    height: 64px;
    object-fit: contain;
`;

const LOGOS = [
    { src: llmsAssets.chatGptLogo, alt: "ChatGPT", automation: "chatgpt" },
    { src: llmsAssets.googleAiModeLogo, alt: "Google AI Mode", automation: "google-ai-mode" },
    { src: llmsAssets.googleAiOverviewLogo, alt: "Google AI Overview", automation: "google-ai-overview" },
];

export const LogoShowcase = () => (
    <Flex
        gap="40px"
        alignItems="center"
        data-automation="llms-channels-logo-showcase"
    >
        {LOGOS.map((logo) => (
            <LogoCardOuter
                key={logo.automation}
                flexDirection="column"
                alignItems="flex-start"
            >
                <LogoCardInner
                    alignItems="center"
                    justifyContent="center"
                >
                    <LogoImg
                        src={logo.src}
                        alt={logo.alt}
                        data-automation={`llms-channels-logo-${logo.automation}`}
                    />
                </LogoCardInner>
            </LogoCardOuter>
        ))}
    </Flex>
);
